import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../layout/material-dashboard-react/components/headerLinksStyle.js";
import classNames from "classnames";
import IconButton from '@mui/material/IconButton';
import Poppers from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import useWindowSize from "app/hooks/useWindowSize.js";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { LoginStatusContext } from "app/context/LoginStatusContext";
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import axios from 'axios';
import Divider from "@material-ui/core/Divider";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import FlightIcon from '@mui/icons-material/Flight';
import SailingOutlinedIcon from '@mui/icons-material/SailingOutlined';
import DirectionsBoatFilledOutlinedIcon from '@mui/icons-material/DirectionsBoatFilledOutlined';

const useStyles = makeStyles(styles);

export default function NavBarNotification(props) {

    const { } = props;

    const { isLoggedIn } = useContext(LoginStatusContext);
    const [openNotification, setOpenNotification] = useState(null);
    const [notifications, setNotifications] = useState([]);

    const menuId = 'primary-search-account-menu';

    const classes = useStyles();
    const windowSize = useWindowSize();

    const handleClickNotification = (event) => {
        if (notifications.length > 0) {
            if (openNotification && openNotification.contains(event.target)) {
                setOpenNotification(null);
            } else {
                setOpenNotification(event.currentTarget);
            }
        }
    };
    const handleCloseNotification = () => {
        setOpenNotification(null);
    };

    const getIcon = (bookingTypeId) => {
        switch (bookingTypeId) {
            case 17:
                return <FlightIcon sx={{ fontSize: 50, color: 'white' }} />
            case 18:
                return <DirectionsBoatFilledOutlinedIcon sx={{ fontSize: 50, color: 'white' }} />
            case 19:
                return <FlightIcon sx={{ fontSize: 50, color: 'white' }} />
            case 20:
                return <DirectionsBoatFilledOutlinedIcon sx={{ fontSize: 50, color: 'white' }} />
            case 100:
                return <SailingOutlinedIcon sx={{ fontSize: 50, color: 'white' }} />
            default:
        }
    }

    const getRef = (notification) => {
        switch (notification.bookingTypeId) {
            case 17:
            case 18:
                sessionStorage.setItem('ShipmentID', notification.referenceId);
                return window.location.href = '/LeoSeaPortal/bookingdetails?shipmentId=' + notification.referenceId;
            case 19:
            case 20:
                sessionStorage.setItem('ShipmentID', notification.referenceId);
                return window.location.href = '/LeoSeaPortal/quotedetails?shipmentId=' + notification.referenceId;
            default:
        }
    }

    function onMouseOverReference(e) {
        e.target.style.textDecorationLine = 'underline';
    }

    function onMouseOutReference(e) {
        e.target.style.textDecorationLine = 'none';
    }

    useEffect(() => {
        //get notifications
        if (isLoggedIn) {
            getNotifications();
        }

        //then get notifications every 30 seconds
        const interval = setInterval(() => {
            if (isLoggedIn) {
                getNotifications();
            }
        }, 30000);
        return () => clearInterval(interval);

        async function getNotifications() {
            return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/notification/GetNotifications`)
                .then((response) => {
                    setNotifications(response.data);
                    sessionStorage.setItem('NotificationsCount', response.data.length);
                });
        }

    }, [isLoggedIn]);

    return (
        <div>
            <IconButton
                size="large"
                aria-label="notifications"
                color="inherit"
                data-testid="headerNotificationButton"
                onClick={handleClickNotification}
            >
                <Badge badgeContent={notifications.length} color="error">
                    <NotificationsIcon />
                </Badge>
            </IconButton>

            <Poppers
                open={Boolean(openNotification)}
                anchorEl={openNotification}
                transition
                disablePortal
                className={
                    classNames({ [classes.popperClose]: !openNotification }) +
                    " " +
                    classes.popperNav
                }
                style={{
                    zIndex: '2'
                }}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        id="notification-menu-list-grow"
                        style={{
                            transformOrigin:
                                placement === "bottom" ? "center top" : "center bottom",
                            maxHeight: "600px",
                            overflowY: 'scroll',
                            backgroundColor: '#FFFFFF'
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleCloseNotification}>
                                <MenuList role="menu">
                                    {notifications.map(notification =>
                                        <><MenuItem className={classes.dropdownItem}
                                            style={{ backgroundColor: notification.notificationColour }}>
                                            <div style={{ display: 'flex' }} class="row">
                                                <div class="column">
                                                    <td style={{
                                                        textDecoration: 'none', zIndex: '-1', width: '1px',
                                                        height: '1px', backgroundColor: notification.notificationColour
                                                    }}
                                                    >{getIcon(notification.bookingTypeId)}</td>
                                                </div>
                                                <div class="column">
                                                    <div>{notification.title}</div>
                                                    <div>{notification.message}</div>
                                                    <div style={{ cursor: 'pointer' }} onMouseOver={onMouseOverReference} onMouseOut={onMouseOutReference} onClick={() => getRef(notification)}>{notification.reference}</div>
                                                </div>
                                            </div>
                                        </MenuItem>
                                            <Divider style={{ height: 8, background: '#FFFFFF' }} /></>
                                    )}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Poppers>
        </div>
    );
}
